import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            var response = await axios.get('/RulesCategories/selectRow',
            {
                params: params
            })
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async save(params)
    {
        try
        {
            var response;
            if (typeof params.id != 'undefined' && params.id != '')
            {
                response = await axios.post('/RulesCategories/updateRow', params);
            }
            else
            {
                response = await axios.post('/RulesCategories/insertRow', params);
            }
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async deleteRow(params)
    {
        try
        {
            var response = await axios.post('/RulesCategories/deleteRow', params);
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    }
}